// extracted by mini-css-extract-plugin
export var card = "_lc-5";
export var cardSelected = "_lc-4";
export var image = "_lc-3";
export var modal = "_lc-0";
export var modalContent = "_lc-1";
export var table = "_lc-2";